import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import {
  PendingFlowEvent,
  FlowName,
} from '@/v2/domains/Analytics/types/common';

type FlowAnalyticsEventsQueueStore = {
  pendingEvents: PendingFlowEvent[];
  flow: FlowName | null;
  setFlow: (flow: FlowName | null) => void;
  enqueueEvent: (eventData: PendingFlowEvent) => void;
  clearPendingEvents: () => void;
};

export const useFlowAnalyticsEventsQueueStore =
  create<FlowAnalyticsEventsQueueStore>()(
    persist(
      (set) => ({
        pendingEvents: [],
        flow: null,

        setFlow: (flow) => {
          set({ flow });
        },

        enqueueEvent: (eventData) => {
          set((state) => ({
            pendingEvents: [
              ...state.pendingEvents,
              { ...eventData, timestamp: Date.now() },
            ],
          }));
        },

        clearPendingEvents: () => {
          set({ pendingEvents: [] });
        },
      }),
      {
        name: 'flow-analytics-events-queue',
        storage: createJSONStorage(() => localStorage),
      }
    )
  );
